module.exports = __webpack_public_path__ + "static/media/donkey.42077af3.gif";